import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-group-offer-basic',
	templateUrl: './group-offer-basic.component.html',
	styleUrls: ['./group-offer-basic.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class GroupOfferBasicComponent implements OnChanges {
	@Input() data: any;
	@Input() products: any;
	@Input() locations: any;
	@Input() editable: boolean;
	@Input() dateRange: any;

	showLocations = [];

	ngOnChanges(changes: SimpleChanges) {
		if (changes['data']) {
			this.updateLocations();
		}
	}

	updateLocations() {
		this.showLocations = [];
		this.data.displayedProducts.forEach((id) => {
			const chosenProduct = this.products.find((element) => element.id == id);
			chosenProduct.location.forEach((location) => {
				this.showLocations.push(location.name);
			});
		});
		this.showLocations = [...new Set(this.showLocations)];
	}
}
